import { DemoUserObject } from "assets/data/usersData";
import { CustomComponentProps } from "utils/types/generalTypes";
import userIcon from "assets/img/user_icon.png";
import SVG from "../core/SVG";
import { Link } from "react-router-dom";
import useWindowSize from "utils/hooks/useWindowSize";

export type NotificationItemProps = CustomComponentProps & {
    user: DemoUserObject;
};

const NotificationItem = ({
    user,
    className,
    style
}: NotificationItemProps) => {
    const [windowWidth] = useWindowSize();
    return (
        <div
            className={`follow-user-li notification-item mb-20 d-flex w-full ${className}`}
            style={style}
        >
            <img src={user.url || userIcon} alt={user.name} />
            <div className="follow-user-li-text d-flex flex-col flex-a-start flex-j-center pl-10 w-full">
                <div
                    className={`d-flex flex-j-between ${windowWidth < 567 ? "flex-a-start" : "flex-a-center"}   gap-5 mb-10 w-full`}
                >
                    <div
                        className={`d-flex ${windowWidth < 567 ? "flex-col flex-a-start" : "flex-a-center"} flex-j-start flex-a-center gap-5`}
                    >
                        <h3>
                            <Link
                                to="/profile"
                                className="dark-grey-text white-text"
                            >
                                {user.name}
                            </Link>
                        </h3>
                        <span
                            className={`momeento-p ${windowWidth < 567 ? "d-none" : ""}`}
                        >
                            -
                        </span>
                        <span
                            className={`momeento-p  ${windowWidth < 567 ? "mb-10" : ""}`}
                        >
                            @{user.username}
                        </span>
                    </div>

                    <span className="momeento-p ml-auto fs-9em black-text white-text">
                        2 min ago
                    </span>
                </div>

                <div className="d-flex flex-j-start flex-a-center gap-5 mb-10">
                    <div className="svg-circle">
                        <SVG svg="tag" size={12} />
                    </div>
                    <span className="momeento-p light-grey-text">
                        Lorem ipsum dolor sit amet.
                    </span>
                </div>
            </div>
        </div>
    );
};

export default NotificationItem;
